var Acre = "Акри";
var Alagoas = "Алагоас";
var Amazonas = "Амазонас";
var Bahia = "Баия";
var Pernambuco = "Пернамбуку";
var Roraima = "Рорайма";
var Sergipe = "Сержипи";
var Tocantins = "Токантинс";
var PTStates = {
	Acre: Acre,
	Alagoas: Alagoas,
	"Amapá": "Амапа",
	Amazonas: Amazonas,
	Bahia: Bahia,
	"Ceará": "Сеара",
	"Federal District": "Федеральный округ",
	"Espírito Santo": "Эспириту-Санту",
	"Goiás": "Гояс",
	"Maranhão": "Мараньян",
	"Mato Grosso": "Мату-Гросу",
	"Mato Grosso do Sul": "Мату-Гросу-ду-Сул",
	"Minas Gerais": "Минас-Жерайс",
	"Pará": "Пара",
	"Paraíba": "Параиба",
	"Paraná": "Парана",
	Pernambuco: Pernambuco,
	"Piauí": "Пиауи",
	"Rio de Janeiro": "Рио-де-Жанейро",
	"Rio Grande do Norte": "Риу-Гранди-ду-Норти",
	"Rio Grande do Sul": "Риу-Гранди-ду-Сул",
	"Rondônia": "Рондония",
	Roraima: Roraima,
	"Santa Catarina": "Санта-Катарина",
	"São Paulo": "Сан-Паулу",
	Sergipe: Sergipe,
	Tocantins: Tocantins
};

export { Acre, Alagoas, Amazonas, Bahia, Pernambuco, Roraima, Sergipe, Tocantins, PTStates as default };
